const SECRET = import.meta.env.VITE_SECRET as string | undefined;

function reverseString(value: string): string {
  return Array.from(value).reverse().join("");
}

function getHashParts(secret: string): { hashPrev: string; hashPost: string } {
  const reversed = reverseString(secret);
  const hashPrev = "\u00f1" + reversed.substring(0, 8);
  const hashPost = "\u00f1" + reversed.substring(reversed.length - 8);
  return { hashPrev, hashPost };
}

function getUtcTicks(): bigint {
  const epochTicks = 621355968000000000n;
  return epochTicks + BigInt(Date.now()) * 10000n;
}

async function sha256Hex(value: string): Promise<string> {
  const data = new TextEncoder().encode(value);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}

export async function buildIdeariaHeaderValue(): Promise<string> {
  if (!SECRET || SECRET.length < 16) {
    throw new Error("VITE_SECRET no configurado o inválido.");
  }

  const ticks = getUtcTicks().toString();
  const { hashPrev, hashPost } = getHashParts(SECRET);
  const payload = hashPrev + ticks + hashPost + "salt2";
  const hash = await sha256Hex(payload);
  return ticks + "_" + hash;
}

export async function buildIdeariaHeaders(base: HeadersInit = {}): Promise<HeadersInit> {
  const headerValue = await buildIdeariaHeaderValue();
  const headers = new Headers(base);
  headers.set("idearia-client-signature", headerValue);
  return headers;
}


